/******************************************************************************************
 *	Demo Mode Controller
 *******************************************************************************************
 *
 * Sets app into demo mode when accessed.
 *
 */
(function() {
  angular.module('rcControllers.demoMode', []).controller(
    'DemoModeController',
    /* @ngInject */
    function($log, $scope, DemoMode, Redirector, CurtainNotifications) {
      var demoModeInitializing = false; //Prevents user from abusing the "Get started" button
      $scope.getStarted = function(event) {
        event.preventDefault();

        if (!demoModeInitializing) {
          demoModeInitializing = true;

          //Enable demo mode
          DemoMode.enable().then(
            function() {
              //Go to default page, which for Demo Mode is the Reseller Admin Dashboard.
              Redirector.go('', true);
            },
            function(error) {
              CurtainNotifications.show(
                CurtainNotifications.ERROR,
                'demoMode.notifications.cannotStartDemoMode'
              );
              demoModeInitializing = false;
              $log.error('Failed to open demo mode', error);
            }
          );
        }
      };
    }
  );
})();
